(function() {
  'use strict';

  angular
    .module('services.sessionExpiration', [])
    .service('SessionExpiration', SessionExpiration);

  SessionExpiration.$inject = ['$window', '$interval'];

  function SessionExpiration($window, $interval) {
    var idleTimer;
    var service = {
      resetIdleTimer: resetIdleTimer,
      stopIdleTimer: stopIdleTimer
    };

    return service;

    function resetIdleTimer() {
      if ($window.mfConfig.isIpad)
        return;

      stopIdleTimer();
      idleTimer = $interval(idleExecution, $window.mfConfig.sessionInactivityExpirationMinutes * 60000, 1, false);
    }

    function idleExecution() {
      $window.location = 'https://' + $window.location.host + '/logout.aspx';
    }

    function stopIdleTimer() {
      if (angular.isUndefined(idleTimer))
        return;

      $interval.cancel(idleTimer);
      idleTimer = undefined;
    }
  }
})();
